module.exports = __webpack_public_path__ + "img/9dd96e8.png";